import formRoutes from 'modules/dominaForm/router'

const mainRoutes = {
  name: 'main',
  component: () => import('modules/shared/layouts/MainLayout.vue'),
  children: [
    {
      path: '/',
      name: 'mainWelcome',
      component: () => import('modules/shared/layouts/WelcomeLayout.vue')
    },
    {
      path: 'domina',
      ...formRoutes
    }
  ]
}

export default mainRoutes